import React from "react";
import {ReactComponent as Icon} from "../../assets/img/robot-svgrepo-com.svg"; // Importa el SVG como componente

const Avatar = ({
                    icon: IconComponent = Icon,
                    backgroundColor = "#f0f0f0",
                    fillColor = "#fff",
                    marginRight = 0,
                    marginLeft = 0,
                    size = 35,
                    alt = "Avatar"
                }) => {
    return (
        <div
            className="avatar"
            style={{
                backgroundColor,
                width: `${size}px`,
                height: `${size}px`,
                borderRadius: "25%", // Hace el contenedor circular
                display: "flex",
                fontSize: "0.9rem",
                marginRight: `${marginRight}px`,
                marginLeft: `${marginLeft}px`,
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden", // Evitar desbordamientos
            }}
        >
            <IconComponent
                style={{
                    width: "80%",
                    height: "80%",
                    fill: "#fff", // Aplica el color dinámico al SVG
                }}
                aria-label={alt} // Accesibilidad
            />
        </div>
    );
};

export default Avatar;
